"use client"

import { memo } from 'react'
import { ClockIcon } from './Icons'
import { formatMarathiDate, timeAgo } from '@/lib/helper'
import { getNewsEffectiveDate } from '@/lib/newsRetentionCore'

const Meta = ({ author, compact, data = null }) => {
    const displayDate = getNewsEffectiveDate(data)

    return (
        <div className={`flex items-center flex-wrap gap-x-2 gap-y-1 text-[11px] text-(--text-tertiary) ${compact ? 'mt-1.5' : 'mt-2.5'}`}>
            {author && (
                <span className="mr truncate max-w-32 sm:max-w-none">
                    {author}
                </span>
            )}

            {author && <span>·</span>}

            <span className="inline-flex items-center gap-1 whitespace-nowrap">
                <ClockIcon />
                <span className="mr">{timeAgo(displayDate)}</span>
            </span>

            <span>·</span>

            <span className="mr whitespace-nowrap">
                {formatMarathiDate(displayDate)}
            </span>
        </div>
    )
}

export default memo(Meta)
